export function getType(obj) {
    return Object.prototype.toString.call(obj);
}

export function isFunction(obj) {
    return getType(obj) === '[object Function]';
}

export function isString(data) {
    return typeof data === 'string';
}

export function isArray(data) {
    return Array.isArray(data);
}

export function isObject(data) {
    return Object.prototype.toString.call(data) === '[object Object]'
}

export function isUndefined(data) {
    return typeof data === 'undefined'
}